export default __webpack_public_path__ + "static/media/background-studio.a369dac9.png";